import { render, staticRenderFns } from "./Classconsumdetails.vue?vue&type=template&id=115316fa"
import script from "./Classconsumdetails.vue?vue&type=script&lang=js"
export * from "./Classconsumdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115316fa')) {
      api.createRecord('115316fa', component.options)
    } else {
      api.reload('115316fa', component.options)
    }
    module.hot.accept("./Classconsumdetails.vue?vue&type=template&id=115316fa", function () {
      api.rerender('115316fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/Classconsumdetails.vue"
export default component.exports